export default __webpack_public_path__ + "static/media/online-bg.164b940c.png";